<template>
  <div class="pt-2 pb-2" :class="tableRowClass" :id="rowId()">
    <v-layout row wrap>
      <v-flex v-for="(header, key) in headers" :key="key" :class="[header.html, textAlign(key)]" pr-1>
        <div v-if="typeStudentName(key)" @click="studentClicked" class="text-xs-left text-bold caption cursor-pointer prevent-overflow">
          <span v-if="nameBreakType === undefined || nameBreakType === 'both'">
            {{student.firstName | nameBreak(nameBreakSize)}} {{student.lastName | nameBreak(nameBreakSize)}}
          </span>
           <span v-else-if="nameBreakType === 'combined'">
            {{combineStudentName | nameBreak(nameBreakSize)}}
          </span>
          <span v-else>
            {{student.firstName}} {{student.lastName}}
          </span>
        </div>

        <rating-badge v-else-if="typeEngagement(key)" @click="studentClicked"
                      :engagement="student[key]"
                      :student-name="ariaLabelName"
                      :type="key"
                      :student-id="student.studentIdentifier"></rating-badge>

        <div v-else-if="typeInterventionAlert(key)" @click="interactionClicked">
        <v-btn :id="interventionAlertId(key)" :aria-label="ariaLabelInterventionAlert(key)" flat icon :disabled="student[key] === 0" >
            <v-icon>{{typeInterventionAlertIcon(key)}}</v-icon>
          </v-btn>
          <v-flex>
            {{student[key]}}
          </v-flex>
        </div>

        <div v-else-if="typeAttendance(key)" @click="attendanceClicked">
          <v-btn :id="attendanceId('btn')" :aria-label="ariaLabelAttendance(key)" flat icon>
            <div class="circle">
              <span v-if="student[key] >= 0">{{student[key] | percent}}</span>
              <span v-else>{{$t('not_applicable')}}</span>
            </div>
          </v-btn>
        </div>

        <div v-else @click="studentClicked" class="text-xs-left text-bold caption cursor-pointer prevent-overflow">
          {{student[key]}}
        </div>
      </v-flex>

      <v-flex v-if="flagEnableStudentActionBtn" class="text-xs-center" xs2 sm1>
        <v-menu lazy top offset-y offset-x content-class="students_ellipsis_menu">
          <v-btn class="students_ellipsis" flat icon slot="activator">
            <v-icon>more_horiz</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="createExemptionForStudent">
              <v-icon class="pr-2">timelapse</v-icon>
              {{$t('exemption.student_list_create')}}
            </v-list-tile>
            <v-list-tile @click="createInterventionForStudent">
              <v-icon class="pr-2">mdi-account-multiple</v-icon>
              {{$t('student_list_create_intervention')}}
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout @click="studentClicked" v-if="$vuetify.breakpoint.xsOnly" row justify-space-between>
      <v-flex xs12>
        <div class="text-xs-left caption text-bold cursor-pointer prevent-overflow">
          {{buildBottomLevel}} {{buildAttendance}}
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import RatingBadge from './RatingBadge'
  import {
    RESET_EXEMPTION_MODULE,
    RESET_INTERVENTION_MODULE,
    SET_DRAWER_COMPONENT,
    SET_DRAWER_STATE,
    SET_INTERVENTION_STUDENT,
    SET_INTERVENTION_STUDENTS
  } from '../../store/mutation-types'
  import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
  import { SET_UNDO_STATE_ASYNC } from '../../store/action-types'
  import CreateInteraction from '../../mixins/CreateInteraction'
  import Helpers from '../../mixins/Helpers'
  import NameBreak from '../../mixins/NameBreak'
  import { HAS_FEATURE_FLAG, GET_STUDENT_TRUNCATION_SIZE, GET_STUDENT_TRUNCATION_TYPE } from '../../store/getter-types'

  export default {
    components: {RatingBadge},
    name: 'studenttablerow',
    props: {
      student: {
        type: Object
      },
      headers: {
        type: Object
      },
      isTopLevel: {
        type: Function
      },
      isIconBased: {
        type: Function
      }
    },
    mixins: [CreateInteraction, Helpers, NameBreak],
    data () {
      return {
        dialog: false
      }
    },
    computed: {
      ...mapState({
        originalHeaders: state => state.students.headers,
        moduleAlert: state => state.profile.module.alert,
        moduleStudent: state => state.profile.module.student,
        moduleInterExem: state => state.profile.module.interexem,
        functionMyStudents: state => state.students.functions.myStudents,
        functionMyStudent: state => state.students.functions.myStudents,
        optionEnableAlertColumn: state => state.students.options.enable.alertColumn,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement,
        optionEnableInterventionColumn: state => state.students.options.enable.interventionColumn,
        optionEnableStudentActionBtn: state => state.students.options.enable.studentActionBtn,
        elementCount: state => state.students.elementCount
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG,
        nameBreakSize: GET_STUDENT_TRUNCATION_SIZE,
        nameBreakType: GET_STUDENT_TRUNCATION_TYPE
      }),
      flagEnableAlertColumn () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionMyStudents + '.' + this.optionEnableAlertColumn)
      },
      flagDisplayAverageEngagementRating () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      },
      flagEnableInterventionColumn () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionMyStudents + '.' + this.optionEnableInterventionColumn)
      },
      flagEnableStudentActionBtn () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionMyStudents + '.' + this.optionEnableStudentActionBtn)
      },
      buildBottomLevel () {
        let txt = []
        Object.keys(this.originalHeaders).forEach(key => {
          if (!this.isTopLevel(key) && key !== 'attendancePercentage') {
            txt.push(this.student[key])
          }
        })
        return txt.join(' | ')
      },
      buildAttendance () {
        if (this.originalHeaders.attendancePercentage) {
          let key = Object.keys(this.originalHeaders).filter(key => key === 'attendancePercentage')
          return this.student[key] >= 0 ? ` | ${this.student[key]}%` : ` | ${this.$t('student_average_attendance')} : ${this.$t('not_applicable')}`
        }
      },
      ariaLabelName () {
        return `${this.student.firstName}-${this.student.lastName}`
      },
      combineStudentName () {
        return this.student.firstName + ' ' + this.student.lastName
      }
    },
    methods: {
      textAlign (type) {
        if (this.isIconBased(type)) {
          return 'text-xs-center'
        }
      },
      typeEngagement (type) {
        return type.includes('Engagement')
      },
      typeStudentName (type) {
        return type === 'studentName'
      },
      typeAttendance (type) {
        return type === 'attendancePercentage'
      },
      typeInterventionAlert (type) {
        return type === 'interventionCount' || type === 'alertCount'
      },
      typeInterventionAlertIcon (type) {
        return type === 'interventionCount' ? 'mdi-account-multiple' : 'alarm'
      },
      studentClicked (event) {
        this.$router.push({path: `student/${this.student.id}`})
      },
      interactionClicked () {
        this.$router.push({name: 'TutorInteractions', params: {id: this.student.id}})
      },
      attendanceClicked () {
        this.$router.push({name: 'TutorAttendance', params: {id: this.student.id}})
      },
      ariaLabelAttendance (type) {
        return `${this.ariaLabelName}-attendance-${this.student[type]}`
      },
      ariaLabelInterventionAlert (type) {
        let key = type === 'interventionCount' ? 'intervention' : 'alert'
        return `${this.ariaLabelName}-${key}-${this.student[type]}`
      },
      interventionAlertId (type) {
        let key = type === 'interventionCount' ? 'intervention' : 'alert'
        return `${this.student.studentIdentifier}-${key}-btn`
      },
      attendanceId (type) {
        return `${this.student.studentIdentifier}-attendance-${type}`
      },
      rowId () {
        return `student-${this.student.id}`
      },
      ...mapMutations({
        addStudentsToInterventionList: SET_INTERVENTION_STUDENTS,
        setDrawerComponent: SET_DRAWER_COMPONENT,
        setDrawerState: SET_DRAWER_STATE,
        setInterventionStudent: SET_INTERVENTION_STUDENT,
        resetIntervention: RESET_INTERVENTION_MODULE,
        resetExemption: RESET_EXEMPTION_MODULE
      }),
      ...mapActions({
        setUndoState: SET_UNDO_STATE_ASYNC
      })
    },
    filters: {
      percent (value) {
        return ((value === undefined) || (value < 0)) ? '' : value + '%'
      }
    }
  }
</script>

<style scoped>
  .btn--icon {
    margin: -1px;
  }

  .row {
    align-items: center;
  }

  .flex {
    padding-left: 1px;
    padding-right: 1px;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .text-bold {
    font-weight: bolder;
  }

  .text-underline {
    text-decoration: underline;
  }

  .prevent-hyphen {
    hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    -webkit-hyphens: none;
  }

  .circle {
    border-radius: 100%;
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    padding-top: 7px;
    color: white;
    background-color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentTableRow.vue